import { render } from "./app-modal-user-detail.vue?vue&type=template&id=3e00c48c"
import script from "./app-modal-user-detail.vue?vue&type=script&lang=js"
export * from "./app-modal-user-detail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/item/app-modal-user-detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e00c48c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e00c48c', __exports__)) {
    console.log('reload')
    api.reload('3e00c48c', __exports__)
  }
  
  module.hot.accept("./app-modal-user-detail.vue?vue&type=template&id=3e00c48c", () => {
    console.log('re-render')
    api.rerender('3e00c48c', render)
  })

}


export default __exports__